import type { AccessStatus } from "../types";
import { accessLabel } from "./apps";
import { el } from "./dom";

/** Dark brand hero band carrying the page title (brand convention). */
export function heroBand(title: string, accent: string, subtitle: string): HTMLElement {
  return el("section", { class: "hero grad-hero" }, [
    el("h1", { class: "hero-title" }, [`${title} `, el("span", { class: "grad-text" }, [accent])]),
    el("p", { class: "hero-sub" }, [subtitle]),
  ]);
}

export function accessBadge(status: AccessStatus): HTMLElement {
  return el("span", { class: `badge badge-${status}` }, [accessLabel(status)]);
}

export function errorBox(message: string): HTMLElement {
  return el("div", { class: "errorbox" }, [message]);
}
